import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import { get } from '@/api';

Vue.use(Vuex);
const vuexPersist = new VuexPersist({
    key: 'dgp_fubon',
    storage: window.localStorage,
});

export default new Vuex.Store({
    state: {
        isLockVeiw: false,
        articleCategory: null,
        displayArticles: 'card',
        searchInputs: { orderby: null, type: null },
        rankingSelects: { category: '', time: null, type: null, count: null },
        // 選單
        menuList: [],
        baseList: [
            {
                imgUrl: require('@/assets/images/menuIcons/list_01.svg'),
                imgActiveUrl: require('@/assets/images/menuIcons/list_01_white.svg'),
                alt: '所有內容',
                label: '所有內容',
                value: '',
                children: [],
            },
            {
                imgUrl: require('@/assets/images/menuIcons/list_05.svg'),
                imgActiveUrl: require('@/assets/images/menuIcons/list_05_white.svg'),
                alt: '保險',
                value: '保險',
            },
            {
                imgUrl: require('@/assets/images/menuIcons/list_06.svg'),
                imgActiveUrl: require('@/assets/images/menuIcons/list_06_white.svg'),
                alt: '健康',
                value: '健康',
            },
        ],
    },
    mutations: {
        LOCKVEIW(state, payload) {
            state.isLockVeiw = payload;
            const element = document.getElementsByTagName('body')[0];
            if (payload) {
                element.className = 'overflowHidden';
            } else {
                element.classList.remove('overflowHidden');
            }
        },
        DISPLAY_ARTICLES(state, payload) {
            state.displayArticles = payload;
        },
        RANKING_SELECTS(state, payload) {
            state.rankingSelects = payload;
        },
        SEARCH_INPUTS(state, payload) {
            state.searchInputs = payload;
        },
        SET_ARTICLE_CATEGORY(state, payload) {
            state.articleCategory = payload;
        },
        // menu選單
        SET_MENULIST(state, payload) {
            state.menuList = state.baseList.map(item => {
                const findItem = payload.find(element => item.value === element.value);
                return { ...item, ...findItem };
            });
        },
        // GA_CLIENT_ID(state, payload) {
        //     state.gaClientId = payload;
        // },
    },
    actions: {
        setLockVeiw(context, payload) {
            context.commit('LOCKVEIW', payload);
        },
        setArticleCategory(context, payload) {
            context.commit('SET_ARTICLE_CATEGORY', payload);
        },
        getMenu(context) {
            get('/api/content/categories').then((res) => {
                context.commit('SET_MENULIST', res.response);
            });
        },
        setDisplayArticles(context, payload) {
            context.commit('DISPLAY_ARTICLES', payload);
        },
        setRankingSelects(context, payload) {
            context.commit('RANKING_SELECTS', payload);
        },
        setSearchInputs(context, payload) {
            context.commit('SEARCH_INPUTS', payload);
        },
        // setGaClientId(context, payload) {
        //     console.log(window.ga);
        //     const timer = setInterval(() => {
        //         if (window.ga) {
        //             const clientId = window.ga.getAll()[0].get('clientId');
        //             clearInterval(timer);
        //             context.commit('GA_CLIENT_ID', clientId);
        //         }
        //     }, 100);
        // context.commit('GA_CLIENT_ID', payload);
        // },
    },
    // getters: {
    //     displayArticles: state => {
    //         return localStorage.getItem('displayArticles') ? localStorage.getItem('displayArticles') : state.displayArticles;
    //     },
    // },
    plugins: [vuexPersist.plugin],
});
